define.alias("shared/components/shared/upgrade/trial-monthly-price", "preview-grid/components/shared/upgrade/trial-monthly-price");